import { render, staticRenderFns } from "./fullScreen.vue?vue&type=template&id=dee11678&scoped=true&"
import script from "./fullScreen.vue?vue&type=script&lang=js&"
export * from "./fullScreen.vue?vue&type=script&lang=js&"
import style0 from "./fullScreen.vue?vue&type=style&index=0&id=dee11678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee11678",
  null
  
)

export default component.exports